<!-- Compiled at 2026-09-18T12:45:23.821Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<Orders-MainLayout
					[$formDirective]="$formDirective"
					[$disabled]="$disabled"
					[$ignoreValidations]="$ignoreValidations"
					[screenTitle]=""
					[isForExternalUser]=""
				>
					<ng-template
						data-content-area="top-right"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<ng-container *lowgileScope="null; screen: this; let $scope">
							<div
								data-content-area="top-right"
								data-defined-in="Orders.VendorOffersProcess"
							></div>
						</ng-container>
					</ng-template>

					<ng-template
						data-content-area="content"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<ng-container *lowgileScope="null; screen: this; let $scope">
							<div
								data-content-area="content"
								data-defined-in="Orders.VendorOffersProcess"
							>
								<ng-container
									*lowgileForm="'form105'; preventNavigation: true; let $formDirective; let form = form"
								>
									<ng-container *ngIf="screen.request.customerOffer"
										><div
											class="layout-block vertical"
											[style.align-items]="'inherit'"
											[style.gap]="'1em'"
										>
											<mat-tab-group
												#$tabGroupControl_98="lowgileTabGroupControl"
												class="has-selectedIndexChange-handler"
												[lowgileSelectedTab]="'comparison'"
												[animationDuration]="300 + 'ms'"
												[mat-stretch-tabs]="false"
											>
												<mat-tab
													[label]="'Customer request'"
													[lowgileTabName]="'request'"
												>
													<ng-container
														*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(true)) as $disabled"
													>
														<Orders-CustomerRequestInclude
															[$formDirective]="$formDirective"
															[$disabled]="$disabled"
															[$ignoreValidations]="$ignoreValidations"
															[request]="screen.request"
														>
														</Orders-CustomerRequestInclude>
													</ng-container>
												</mat-tab>
												<mat-tab
													[label]="'Vendor offers'"
													[lowgileTabName]="'offers'"
												>
													<Orders-VendorOffersInclude
														[$formDirective]="$formDirective"
														[$disabled]="$disabled"
														[$ignoreValidations]="$ignoreValidations"
														[request]="screen.request"
													>
													</Orders-VendorOffersInclude>
												</mat-tab>
												<mat-tab
													[label]="'Price comparison'"
													[lowgileTabName]="'comparison'"
												>
													<Orders-VendorOffersComparisonInclude
														[$formDirective]="$formDirective"
														[$disabled]="$disabled"
														[$ignoreValidations]="$ignoreValidations"
														[request]="screen.request"
													>
													</Orders-VendorOffersComparisonInclude>
												</mat-tab>
											</mat-tab-group>
											<div
												class="layout-block"
												[style.align-items]="'inherit'"
												[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
												[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
												[style.gap]="'1em'"
											>
												<ng-container
													*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(form.invalid || !screen.request.customerOffer.offerFilename)) as $disabled"
												>
													<button
														mat-raised-button
														class="has-click-handler"
														color="primary"
														(click)="handler_ButtonBlock_25_click_$adhoc_0($event, { form, $disabled: $disabled })"
														[disabled]="$disabled"
													>
														<mat-icon>{{'send'}}</mat-icon
														><span
															[innerHtml]="'Send offer to customer' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</button>
												</ng-container>
												<ng-container
													*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(form.pristine)) as $disabled"
												>
													<button
														mat-raised-button
														class="has-click-handler"
														color="basic"
														(click)="handler_ButtonBlock_106_click_$adhoc_0($event, { form, $disabled: $disabled })"
														[disabled]="$disabled"
													>
														<mat-icon>{{'save'}}</mat-icon
														><span
															[innerHtml]="'Save' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</button>
												</ng-container>
											</div></div
									></ng-container>
								</ng-container>
							</div>
						</ng-container>
					</ng-template>
				</Orders-MainLayout>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
